
export const ENVIRONMENT = 'PRODUCTION';

const getAppUrl = () => {
    if(ENVIRONMENT === 'LOCAL')
        return ('http://localhost:8000');

    if(ENVIRONMENT === 'STAGING')
        return 'https://api.mbr.astwarehosting.com';

    if(ENVIRONMENT === 'PRODUCTION')
        return 'https://api.mundorenal.com';
};

export const APP_URL = getAppUrl();
export const API_URL = APP_URL + '/api';

export const PUSHER_KEY = '';

export const COLOR_PRIMARY = '#f30707';

export const COLOR_SECONDARY = '#349cdc';
